import React, { useState } from "react";
import FrameComponent10 from "./FrameComponent10";
import PropTypes from "prop-types";
import Testlink from "./Testlink";
import { useLocation } from "react-router-dom";
import { Container } from '@/components/ui/container';
import { Stack } from '@/components/ui/layout';
import { Heading } from '@/components/ui/typography';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn } from '@/lib/utils';
import { ArrowRight } from 'lucide-react';

const Navigation1 = ({ className = "" }) => {
  const location = useLocation();
  const selectedUsers = location.state?.selectedUsers || null;

  console.log(selectedUsers);
  const [showPopup, setShowPopup] = useState(false);
  const [testId, setTestId] = useState("");

  const [topic, setTopic] = useState("");
  const [difficulty, setDifficulty] = useState("");
  const [scheduledTime, setScheduledTime] = useState("");

  const handleButtonClick = async () => {
    console.log("Form Data:", { topic, difficulty, scheduledTime, selectedUsers });

    if (!topic || !difficulty || !scheduledTime) {
      alert("Please fill all fields.");
      return;
    }

    const formData = new FormData();
    formData.append("topic", topic);
    formData.append("difficulty", difficulty);
    formData.append("scheduledTime", scheduledTime);
    formData.append("selected_users", JSON.stringify(selectedUsers));

    try {
      const response = await fetch("/api/schedule_test", {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      setTestId(data.test_id);
      console.log("Set Test ID: ", testId);
      setShowPopup(true);
    } catch (error) {
      console.error("Error scheduling the test:", error);
      alert("An error occurred while scheduling the test.");
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const topics = [
    "Artificial Intelligence",
    "Full Stack Web Development",
    "Frontend Web Development",
    "React",
    "Flutter or Dart",
    "AWS DevOps",
    "Python",
    "Power BI",
    "Tableau",
    "Snowflake",
    "Data Analytics",
    "Digital Marketing",
    "Product Manager",
    "Sales",
    "Finance",
  ];

  const difficultyLevels = ["Beginner", "Intermediate", "Advanced"];

  return (
    <section className={cn("relative w-full", className)}>
      <Container>
        <Stack spacing="lg" align="center" className="py-8">
          <Heading level="h2" className="text-3xl font-semibold text-foreground">
            Choose Your Screening Test
          </Heading>
          <Stack spacing="md" className="w-full max-w-2xl">
            <FrameComponent10
              selectTopic="Select Topic:"
              selectTopic1="Select Topic:"
              type="select"
              options={topics}
              value={topic}
              onChange={(e) => setTopic(e.target.value)}
            />
            <FrameComponent10
              frameDivGap="185px"
              selectTopic="Select Difficulty Level:"
              selectTopicColor="#fff"
              selectTopic1="Select Level:"
              type="difficulty"
              options={difficultyLevels}
              value={difficulty}
              onChange={(e) => setDifficulty(e.target.value)}
            />
            <FrameComponent10
              frameDivGap="196px"
              selectTopic="Schedule Date/Time:"
              selectTopicColor="#f1f1f1"
              selectTopic1="Select Date/Time:"
              type="datetime"
              value={scheduledTime}
              onChange={(e) => setScheduledTime(e.target.value)}
            />
            <Button onClick={handleButtonClick} size="lg" className="w-full mt-4">
              <ArrowRight className="w-5 h-5 mr-2" />
              Get Schedule Test Link
            </Button>
          </Stack>
        </Stack>
      </Container>

      <Dialog open={showPopup} onOpenChange={setShowPopup}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>Test Link Generated</DialogTitle>
          </DialogHeader>
          <Testlink testId={testId} />
        </DialogContent>
      </Dialog>
    </section>
  );
};

Navigation1.propTypes = {
  selectedUsers: PropTypes.array.isRequired,
  className: PropTypes.string,
};

export default Navigation1;
